import styled from 'styled-components';

export const Content = styled.div`
  /* height: 430px; */
  max-height: 65.4ch;
  overflow-y: auto;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.2;
  img {
    line-height: 1;
    border-radius: 3px;
    max-width: 100%;
    height: auto;
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;
